export const LOGIN_TITLE = {
	doctor: 'Physician Login',
	pharma: 'Pharmacy Login',
	patient: 'Patient Login',
};

export const LABEL = {};
